import { lazy } from 'react'

// TNMC-236: a release removes the previous build's hashed chunk files from
// Hosting.
const RELOADED_KEY = 'chunkLoadReloadedFor'
const MAX_REMEMBERED = 20

const isChunkLoadError = (error) =>
  error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk \S+ failed/i.test(error?.message || '')

// Keyed on what failed, not when: a chunk that hangs until webpack's 120s
// chunk timeout fails long after any time window, so a window would reload
// forever. Chunk URLs are content-hashed, so the next release's missing chunk
// is a new key and still gets its reload.
const chunkKey = (error) => error?.request || error?.message || 'unknown'

// Returns false when this tab already reloaded for the chunk, or when storage
// is unavailable, since then the loop guard can't work
const recordReload = (key) => {
  try {
    const reloaded = JSON.parse(sessionStorage.getItem(RELOADED_KEY) || '[]')
    if (reloaded.includes(key)) return false
    sessionStorage.setItem(RELOADED_KEY, JSON.stringify([...reloaded, key].slice(-MAX_REMEMBERED)))
    return true
  } catch {
    return false
  }
}

export const loadWithReload = (factory) =>
  factory().catch((error) => {
    if (!isChunkLoadError(error)) throw error
    if (!recordReload(chunkKey(error))) throw error
    window.location.reload()
    // Keep the Suspense fallback up until the reload takes over
    return new Promise(() => {})
  })

const lazyWithReload = (factory) => lazy(() => loadWithReload(factory))

export default lazyWithReload
